<template>
  <div>
    <div id="qrcode" class="qrcode" v-loading="loading">
      <img class="qrcodeImg" :src="qrcodeUrl" v-if="qrcodeUrl">
      <div class="fail_mask" v-if="type==1&&!agreeXieyi">
        <!-- <span class="refreshbox">
          <img class="qrcode_ref_icon" src="../assets/img/refresh.png">
        </span> -->
        <span class="agreeXieyiTxt">{{$t('m.please_agree_agree')}}</span>
      </div>
      <div class="fail_mask" @click="getQrcodeInfo()" v-else-if="qrCodeTimeOut">
        <span class="refreshbox">
          <img class="qrcode_ref_icon" src="../assets/img/refresh.png">
        </span>
      </div>
    </div>
    <div class="direction_ltr scantip">
      {{$t('m.open_code')}}
      <img class="scanicon" src="../assets/img/scan.png">
    </div>
  </div>
</template>
<script>
  import QRCode from 'qrcode';
  import { generateQrcodeKey,checkQrcode } from "@/api/common";

  var _self;
  export default {
    name: 'scan',
    props:{
      type: {
        type: Number,
        default () {
          return null;
        }
      },
      agreeXieyi: {
        type: Boolean,
        default () {
          return false;
        }
      },
    },
    data() {
      return {
        token: '',
        isLunxun: true,
        qrcode: '',
        qrcodeUrl: '',
        qrCodeTxt: 'https://www.facecast.live/x/',
        qrCodeMd5: '',
        timer: null,
        qrCodeTimeOut: false,

        loading:false,
      }
    },
    mounted() {
      _self = this;
      _self.qrcodeUrl = '';

      _self.loading=true;
      _self.getQrcodeInfo();

    },
    destroyed() {
      console.log("ending");
      _self.isLunxun = false;
      _self.qrcodeUrl = '';
    },
    methods: {
      gotoask() {
        _self.isLunxun = false;
        _self.$router.push({
          name:'loginCourse'
        })
      },
      selCountryConfirm(val, index) {
        //console.log(val);
        _self.currentCountryIndex = index;
        _self.showcountryPicker = false;
      },


      initQrcode(url) {
        QRCode.toDataURL(url, {
            width: 300,
            height: 300,
            type: 'image/jpeg',
            quality: 0.3,
            margin: 1.5
          })
          .then(url => {
            //console.log(url);
            _self.qrcodeUrl = url;
            _self.qrCodeTimeOut = false;
          })
          .catch(err => { //异常时的处理
            console.error(err)
          })


      },
      getQrcodeInfo() {
        // 1登录 2绑定 3换绑
        generateQrcodeKey(this.type).then(({ data }) => {
          _self.loading=false;
          if (data.code == 1) {
            _self.qrCodeMd5 = data.data.randNum;
            console.log(data);
              //_self.qrCodeMd5 = Math.random()*1000;
              _self.initQrcode(_self.qrCodeTxt + _self.qrCodeMd5);
              _self.isLunxun = true;
              _self.checkQrcode();
          }
        })
        .catch((error) => {
          console.log(error) //  错误处理 相当于error
          _self.qrCodeTimeOut = true;
          _self.loading=false;
        });
      },
      //检查qrcode是否有效
      checkQrcode() {
        checkQrcode(_self.qrCodeMd5).then(({ data }) => {
          //console.log(data);
          if (data.code == 1) {
            switch (data.data.status) {
              //0-未扫码 1-未登录 2-已登录 3-已过期
              case 0:
                _self.qrCodeTimeOut = false;
                break;
              case 1:
                break;
              case 2:
                //clearInterval(_self.timer);
                //Toast('已登录');
                if(_self.type==1){
                  // 登录
                  _self.goLogin(data.data);
                }else if(_self.type==2){
                  // 绑定
                  _self.isLunxun = false;
                  this.$emit('success',data.data)
                }else if(_self.type==3){
                  // 换绑
                  _self.isLunxun = false;
                  this.$emit('success',data.data)
                }
                break;
              case 3:
                //Toast('已过期');
                _self.isLunxun = false;
                _self.qrCodeTimeOut = true;
                //clearInterval(_self.timer);
                break;
              default:
                break;
            }
            if (_self.isLunxun) {
              setTimeout(function() {
                _self.checkQrcode();
              }, 1000);
            }

          } else {
            _self.isLunxun = false;
            _self.qrCodeTimeOut = true;
          }

        }).catch((error) => {
          console.log(error);
          //clearInterval(_self.timer);
          _self.isLunxun = false;
          _self.qrCodeTimeOut = true;
        })


      },
      goLogin(data){
        // 0：用户已绑定手机号--登录成功 1：用户不存在---提示绑定手机号，设置密码，用户进行注册 2：用户存在，但未绑定手机号----提示绑定手机号、设置密码，更新用户信息
        let userBindState = data.userVo.userBindState
        if(userBindState === 2) {
          this.$store.commit('setUser', data.userVo);
        }
        if(userBindState !== 0) {
          this.$emit('showBindDialog', data.userVo)
          return
        }
        // console.log(data);
        this.$store.commit('setUser', data.userVo);
        if(data.userVo.status===3){
            //已入驻
            this.$router.push({
              path: '/guild/my-guild-detail'
            });
          }else{
            //0未申请入驻 1入驻申请未通过
            this.$router.push({
              name: 'apply-index',
              params:{
                userStatus:data.userVo.status,
                stepActive:data.userVo.status==0?0:2,
              },
              query:{
                inviteCode: this.$route.query.inviteCode
              }
            });
          }
      },

    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.fail_mask{
	position: absolute;
	width: 2.7rem;
	height: 2.7rem;
	top: 0;
	left: 50%;
	margin-left: -1.35rem;
	background-color: rgba(255,255,255,.9);

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.qrcode{
  width: 2.7rem !important;
  height: 2.7rem !important;
	margin:.56rem auto .2rem;
  position: relative;
  text-align: center;
  border: 1px solid #EDEEF0;
  border-radius: .12rem;
  overflow: hidden;
}
.qrcodeImg{
	width: 2.7rem !important;
	height: 2.7rem !important;
}

.refreshbox{
  display: inline-block;
  width: .14rem;
	height: .14rem;
  padding: .18rem;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 .04rem .12rem 0 rgba(0,0,0,0.2);
}
.agreeXieyiTxt{
  font-size: 14px;
  padding: 15px;
}
.qrcode .qrcode_ref_icon{
	width: 100%;
	height: 100%;
  vertical-align: top;
}
.scantip{
  color: #999;
  font-size: .14rem;
  text-align: center;
}
.scanicon{
  width: .2rem;
  height: .2rem;
}

@media only screen and (max-width: 767px) {
  .scantip{
    font-size: .2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scan.vue